import { GetNetSuiteCustomer } from 'shared/data/webApp/v2';

import { mapCustomerAddresses } from '../../../helpers';

export const mapShipToData = (customer: GetNetSuiteCustomer['response'] | undefined) => {
    if (!customer || !customer.id || !customer.name) {
        return null;
    }

    const shipToData = {
        id: customer.id,
        text: customer.name,
        addresses: mapCustomerAddresses(customer.addresses),
    };

    return shipToData;
};
